import React from 'react'

import { CookieBanner } from './cookie-banner'
import { CookieSettingsModal } from './cookie-settings-modal'

import { useCookieConsent } from '../hooks/use-cookie-consent'

export const CookieConsent: React.FC = () => {
  const {
    consent,
    showBanner,
    showSettings,
    acceptAll,
    rejectAll,
    saveCustomSettings,
    openSettings,
    closeSettings,
    closeBanner,
  } = useCookieConsent()

  return (
    <>
      <CookieBanner
        isVisible={showBanner}
        onAcceptAll={acceptAll}
        onRejectAll={rejectAll}
        onOpenSettings={() => {
          closeBanner()
          openSettings()
        }}
      />
      <CookieSettingsModal
        isOpen={showSettings}
        onClose={closeSettings}
        onSave={saveCustomSettings}
        currentSettings={consent?.settings}
      />
    </>
  )
}
